import axios from "axios";
import React, { useState } from "react";
import { headers } from "../../../exports/exports";
import { dynamicFailed, dynamicSuccess } from "../../../hooks/useToast";
import { IMemberListData } from "../../../exports/interfaces";
import { useLoader } from "../../../context/LoaderContext";
import DynamicToolTip from "../../DynamicToolTip";
import type { Slide } from "yet-another-react-lightbox";
// import DeletePopUp from "../../DeletePopUp";
import QrPopup from "./QrPopup";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";
import { formatTime, getFormattedDate } from "../../../exports/functions";
import useMobile from "../../../hooks/useMobile";
import { useUserDataContext } from "../../../context/UserDataContext";
import { sendErrorLog } from "../../ErrorLog";

type UploadData = {
  [key: string]: {
    data: {
      id: number;
      attributes: {
        name: string;
        ext: string;
        url: string;
      };
    };
  };
};

const Uploads = (props: {
  listMemberData: IMemberListData[];
  memberId: number;
  getUserById: () => void;
  user?: string;
}) => {
  const { setLoading } = useLoader();
  const mobile = useMobile();
  const [open, setOpen] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);
  const { userData } = useUserDataContext();

  const [selectedFiles, setSelectedFiles] = useState<{ [key: number]: File }>(
    {},
  );
  const [previews, setPreviews] = useState<{ [key: number]: string }>({});
  // const [fieldName, setFieldName] = useState<string>("");

  const lightboxSlides = (
    props?.listMemberData[0]?.attributes?.Payment_Reciept?.data || []
  )
    .slice()
    .sort(
      (a: any, b: any) =>
        new Date(b?.attributes?.createdAt).getTime() -
        new Date(a?.attributes?.createdAt).getTime(),
    )
    .map((item: any) => {
      const mimeType = item?.attributes?.mime;
      const url = item?.attributes?.url;
      const createdAt = item?.attributes?.createdAt;
      const nepalDate = new Date(
        new Date(createdAt).toLocaleString("en-US", {
          timeZone: "Asia/Kathmandu",
        }),
      );
      const formattedDate = `${nepalDate.getFullYear()}-${String(
        nepalDate.getMonth() + 1,
      ).padStart(2, "0")}-${String(nepalDate.getDate()).padStart(2, "0")}`;
      const timeString = `${String(nepalDate.getHours()).padStart(
        2,
        "0",
      )}:${String(nepalDate.getMinutes()).padStart(2, "0")}`;
      const formattedTime = formatTime(timeString);
      const formattedDateTime = `${formattedDate}, ${formattedTime}`;

      if (mimeType?.startsWith("image")) {
        return {
          type: "image",
          src: url && `${process.env.REACT_APP_strapiUrl}${url}`,
          description: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>{formattedDateTime}</span>
              <a
                href={`${process.env.REACT_APP_strapiUrl}${url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="thm-btn main-header-two__btn custom-main-header-two__btn custom-donate-btn"
              >
                View
              </a>
            </div>
          ),
        };
      }

      if (mimeType === "application/pdf") {
        return {
          type: "image",
          src: "https://cdn-icons-png.flaticon.com/512/4208/4208479.png",
          description: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>{formattedDate}</span>
              <a
                href={`${process.env.REACT_APP_strapiUrl}${url}`}
                target="_blank"
                rel="noopener noreferrer"
                className="thm-btn main-header-two__btn custom-main-header-two__btn custom-donate-btn"
              >
                View
              </a>
            </div>
          ),
        };
      }

      return null;
    })
    .filter(Boolean) as Slide[];

  const uploadList: UploadData =
    props?.listMemberData[0]?.attributes?.bi_frcsit_user_upload?.data
      ?.attributes || {};

  const uploadFields = [
    { id: 1, label: "Photograph", types: "png, jpg, jpeg", name: "Photograph" },
    {
      id: 2,
      label: "Bachelor Degree",
      types: "png, jpg, jpeg, pdf",
      name: "Bachelor_Degree",
    },
    {
      id: 3,
      label: "Master Degree",
      types: "png, jpg, jpeg, pdf",
      name: "Master_Degree",
    },
    {
      id: 4,
      label: "MCI/State Council Registration",
      types: "png, jpg, jpeg, pdf",
      name: "MCI",
    },
    {
      id: 5,
      label: "Photo ID (Aadhar/Driving License/Voter ID/Passport)",
      types: "png, jpg, jpeg",
      name: "Photo_ID",
    },
    {
      id: 6,
      label: "Curriculum Vitae",
      types: "pdf",
      name: "Curriculum_Vitae",
    },
    {
      id: 7,
      label: "Payment Receipt",
      types: "png, jpg, jpeg, pdf",
      name: "Payment_Receipt",
    },
  ];

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: number,
  ) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setSelectedFiles((prev) => ({
        ...prev,
        [id]: file,
      }));

      const url = URL.createObjectURL(file);
      setPreviews((prev) => ({
        ...prev,
        [id]: url,
      }));
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const uploadedFileIds: { [key: number]: number } = {};

      // Step 1: Upload each file
      for (const id in selectedFiles) {
        const file = selectedFiles[Number(id)];
        const formData = new FormData();
        formData.append("files", file);

        try {
          const uploadRes = await axios.post(
            `${process.env.REACT_APP_strapiUrl}/api/upload`,
            formData,
            {
              headers: {
                Authorization: headers.Authorization,
                "Content-Type": "multipart/form-data",
              },
            },
          );

          if (!uploadRes.data || !uploadRes.data[0]?.id) {
            throw new Error("File upload failed. Invalid response.");
          }

          uploadedFileIds[Number(id)] = uploadRes.data[0].id;
        } catch (uploadError: any) {
          dynamicFailed("File upload failed. Please try again.");
          await sendErrorLog(
            "User Update Error",
            `${props.listMemberData[0].attributes.First_Name} ${props.listMemberData[0].attributes.Last_Name}`,
            props.listMemberData[0].attributes.Email,
            props.listMemberData[0].attributes.Mobile_Number,
            uploadError?.config?.url,
            uploadError.message,
            undefined,
            "File upload failed. Please try again.",
          );
          setLoading(false);
          return;
        }
      }

      // Step 2: Prepare update data
      const updateData: { [key: string]: any } = {};
      let paymentReceiptId: number | null = null;

      uploadFields.forEach((field) => {
        const fileId = uploadedFileIds[field.id];
        if (field.id === 7 && fileId) {
          paymentReceiptId = fileId;
        } else if (fileId) {
          updateData[field.name] = fileId;
        }
      });

      updateData["be_frcsit_user"] = props.memberId;

      const existingUploadId =
        props?.listMemberData?.[0]?.attributes?.bi_frcsit_user_upload?.data?.id;

      if (!existingUploadId) {
        dynamicFailed("Upload record not found. Cannot update.");
        setLoading(false);
        return;
      }

      // Step 3: Update frcsit-user-uploads
      try {
        const userRes = await axios.put(
          `${process.env.REACT_APP_strapiUrl}/api/frcsit-user-uploads/${existingUploadId}`,
          { data: updateData },
          { headers },
        );

        if (userRes?.status !== 200) {
          throw new Error("Upload update failed.");
        }
      } catch (uploadUpdateError: any) {
        dynamicFailed("Failed to update uploaded data.");
        await sendErrorLog(
          "User Update Error",
          `${props.listMemberData[0].attributes.First_Name} ${props.listMemberData[0].attributes.Last_Name}`,
          props.listMemberData[0].attributes.Email,
          props.listMemberData[0].attributes.Mobile_Number,
          uploadUpdateError?.config?.url,
          uploadUpdateError.message,
          undefined,
          "Failed to update uploaded data.",
        );
        setLoading(false);
        return;
      }

      // Step 4: Update Payment_Receipt if available
      if (paymentReceiptId) {
        try {
          const oldPaymentReceipts =
            props?.listMemberData?.[0]?.attributes?.Payment_Reciept?.data?.map(
              (item: { id: number }) => item.id,
            ) || [];

          const updatedPaymentReceipts = [
            ...oldPaymentReceipts,
            paymentReceiptId,
          ].filter(Boolean);

          const updatePayment: any = {
            Payment_Reciept: updatedPaymentReceipts,
            Payment_Received: true,
          };

          if (props?.listMemberData[0]?.attributes?.Status === "Expired") {
            updatePayment.Status = "Approved";
          }

          await axios.put(
            `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${props?.listMemberData[0]?.id}`,
            { data: updatePayment },
            { headers },
          );
          const message = {
            data: {
              Message:
                "Your payment receipt is under review. Please wait until it’s approved.",
              Type: "status",
              bf_frcsit_user: props?.listMemberData[0]?.id,
            },
          };
          await axios.post(
            `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
            message,
            { headers },
          );
          const currentYear = getFormattedDate(0, 0).slice(0, 4);
          const fullName =
            `${props?.listMemberData[0]?.attributes?.First_Name} ${props?.listMemberData[0]?.attributes?.Middle_Name} ${props?.listMemberData[0]?.attributes?.Last_Name}`
              .replace(/\s+/g, " ")
              .trim();
          const email = props?.listMemberData[0]?.attributes?.Email;

          const notificationUser = {
            sisID: 1232,
            email,
          };

          const adminUsers = [
            {
              sisID: 1233,
              email: "frcsitsecretary@gmail.com",
            },
            {
              sisID: 1234,
              email: "secretary@frcsit.com",
            },
          ];
          await axios.post(
            `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
            {
              templateId: "5f1a9b5a-0213-439b-b1ab-45fdc46f7061",
              senderId: 5171,
              payload: {
                FullName: fullName,
                CurrentYear: currentYear,
              },
              users: [notificationUser],
            },
          );

          await axios.post(
            `${process.env.REACT_APP_NOTIFICATION_URL}/notification`,
            {
              templateId: "1c752376-7f19-43f7-865f-e919e0d4913b",
              senderId: 5171,
              payload: {
                FullName: fullName,
                CurrentYear: currentYear,
              },
              users: adminUsers,
            },
          );
        } catch (paymentUpdateError: any) {
          dynamicFailed("Payment receipt update failed.");
          await sendErrorLog(
            "User Update Error",
            `${props.listMemberData[0].attributes.First_Name} ${props.listMemberData[0].attributes.Last_Name}`,
            props.listMemberData[0].attributes.Email,
            props.listMemberData[0].attributes.Mobile_Number,
            paymentUpdateError?.config?.url,
            paymentUpdateError.message,
            undefined,
            "Payment receipt update failed.",
          );
          setLoading(false);
          return;
        }
      }

      // Step 5: If status is 'Rejected', set to 'Pending'
      if (
        props?.listMemberData[0]?.attributes?.Status === "Rejected"
        // userData?.data?.roles[0]?.name === "member"
      ) {
        try {
          await axios.put(
            `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${props?.listMemberData[0]?.id}`,
            {
              data: {
                Status: props?.listMemberData[0]?.attributes.Payment_Received
                  ? "Approved"
                  : "Pending",
              },
            },
            { headers },
          );
          const message = {
            data: {
              Message: props?.listMemberData[0]?.attributes.Payment_Received
                ? "Your payment receipt is under review. Please wait until it’s approved."
                : "Your account is under review. Please wait until it’s approved to make payment.",
              Type: "status",
              bf_frcsit_user: props?.listMemberData[0]?.id,
            },
          };
          await axios.post(
            `${process.env.REACT_APP_strapiUrl}/api/frcsit-notices`,
            message,
            { headers },
          );
        } catch (statusUpdateError: any) {
          dynamicFailed("Failed to update user status.");
          await sendErrorLog(
            "User Update Error",
            `${props.listMemberData[0].attributes.First_Name} ${props.listMemberData[0].attributes.Last_Name}`,
            props.listMemberData[0].attributes.Email,
            props.listMemberData[0].attributes.Mobile_Number,
            statusUpdateError?.config?.url,
            statusUpdateError.message,
            undefined,
            "Failed to update user status.",
          );
          setLoading(false);
          return;
        }
      }

      // Final Success Actions
      props.getUserById();
      dynamicSuccess("Profile updated successfully!");
      setSelectedFiles({});
      setPreviews({});
    } catch (e: any) {
      await sendErrorLog(
        "User Update Error",
        `${props.listMemberData[0].attributes.First_Name} ${props.listMemberData[0].attributes.Last_Name}`,
        props.listMemberData[0].attributes.Email,
        props.listMemberData[0].attributes.Mobile_Number,
        e?.config?.url,
        e.message,
      );
      dynamicFailed(`${e.message}`);
    } finally {
      setLoading(false);
    }
  };

  // const handleDelete = async (fieldName: string) => {
  //   setLoading(true);
  //   try {
  //     const fileId = uploadList?.[fieldName]?.data?.id;
  //     await axios.delete(
  //       `${process.env.REACT_APP_strapiUrl}/api/upload/files/${fileId}`,
  //       { headers }
  //     );

  //     const uploadEntryId =
  //       props?.listMemberData[0]?.attributes?.bi_frcsit_user_upload?.data?.id;

  //     await axios.put(
  //       `${process.env.REACT_APP_strapiUrl}/api/frcsit-user-uploads/${uploadEntryId}`,
  //       {
  //         data: { [fieldName]: null },
  //       },
  //       { headers }
  //     );

  //     success();
  //     props.getUserById();
  //   } catch (error) {
  //     failed();
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <>
      <div className="user-card__header">
        <div className="user-card__info" style={{ marginLeft: "unset" }}>
          <h3>Uploads</h3>
        </div>
      </div>
      <hr />
      {uploadFields.map((field) => {
        const fileData = uploadList?.[field.name]?.data;
        const preview = previews[field.id];
        const selectedFile = selectedFiles[field.id];

        return (
          <div className="upload-item" key={field.id}>
            <div className="upload-label" style={{
                    ...(mobile && field.id === 7 && { width: '100%' }),
                  }}>
              <p className="upload-title">
                <span
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: "10px",
                  }}
                >
                  {field.id}. {field.label}
                  {field.id === 7 && (
                    <div style={{ display: "flex", gap: "5px" }}>
                      {(props?.listMemberData[0]?.attributes?.Status ===
                        "Approved" ||
                        (props?.listMemberData[0]?.attributes
                          ?.Payment_Received &&
                          props?.listMemberData[0]?.attributes?.Status ===
                            "Rejected") ||
                        props?.listMemberData[0]?.attributes?.Status ===
                          "Expired" ||
                        userData?.data?.roles[0]?.name === "sa") && (
                        <span
                          className="upload-subtext view-qr-link"
                          onClick={() => setQrOpen(true)}
                        >
                          View QR
                        </span>
                      )}
                      <span
                        className="upload-subtext view-qr-link"
                        onClick={() => setOpen(true)}
                      >
                        View Payment History
                      </span>
                    </div>
                  )}
                </span>
                <p
                  className="upload-subtext"
                  style={{
                    ...(field.id === 7 && { marginBottom: 0 }),
                  }}
                >
                  <span>Allowed file types: {field.types}</span>
                </p>
                {field.id === 7 && (
                  <span
                    className="upload-subtext"
                    style={{
                      fontStyle: "italic",
                      fontWeight: "bolder"
                    }}
                  >
                    *Check uploaded receipt in View Payment History
                  </span>
                )}
              </p>
            </div>

            <div className="col-xl-4">
              {preview || fileData ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: mobile ? "15px" : "25px",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="user-card__image"
                    style={{
                      position: "relative",
                      textAlign: "center",
                    }}
                  >
                    {(() => {
                      const src = preview
                        ? preview
                        : `${process.env.REACT_APP_strapiUrl}${fileData?.attributes?.url}`;
                      const isPdf =
                        (preview && selectedFile?.type === "application/pdf") ||
                        (!preview && fileData?.attributes?.ext === ".pdf");

                      return isPdf ? (
                        preview ? (
                          <iframe
                            src={src}
                            title="PDF Preview"
                            style={{
                              width: "60px",
                              height: "60px",
                              border: "1px solid #ccc",
                            }}
                          />
                        ) : (
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/4208/4208479.png"
                            alt="PDF Icon"
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                              border: "1px solid #ccc",
                            }}
                          />
                        )
                      ) : (
                        <img
                          src={src}
                          alt="Preview"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                            border: "1px solid #ccc",
                          }}
                        />
                      );
                    })()}

                    <div
                      className="edit-profil-pic-icon"
                      style={{
                        top: "0px",
                        left: "45px",
                        position: "absolute",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        document
                          .getElementById(`file-upload-${field.id}`)
                          ?.click()
                      }
                    >
                      <span className="icon-pencil"></span>
                    </div>
                  </div>
                  {fileData?.attributes?.url && (
                    <a
                      href={`${process.env.REACT_APP_strapiUrl}${fileData.attributes.url}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <DynamicToolTip title="View">
                        <button
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          <span className="icon-eye"></span>
                        </button>
                      </DynamicToolTip>
                    </a>
                  )}
                </div>
              ) : (
                (() => {
                  const role = userData?.data?.roles[0]?.name;
                  const attributes = props?.listMemberData[0]?.attributes;

                  const statusCondition =
                    attributes?.Status === "Approved" ||
                    (attributes?.Payment_Received &&
                      attributes?.Status === "Rejected") ||
                    attributes?.Status === "Expired";

                  let canUpload = false;

                  if (field.id === 7) {
                    // Payment Receipt → both sa and member BUT only if status condition true
                    canUpload =
                      statusCondition && (role === "sa" || role === "member");
                  } else {
                    // All other fields → only sa (no status condition)
                    canUpload = role === "sa";
                  } // Only Payment Receipt for member

                  return (
                    <>
                      {canUpload && (
                        <div className="become-volunteer__input custom-file-input">
                          <label htmlFor={`file-upload-${field.id}`}>
                            Click To Upload {field.label}
                          </label>
                        </div>
                      )}
                    </>
                  );
                })()
              )}

              <input
                type="file"
                id={`file-upload-${field.id}`}
                name={`file-upload-${field.id}`}
                accept={field.types
                  .split(",")
                  .map((type) => `.${type.trim()}`)
                  .join(",")}
                onChange={(e) => handleFileChange(e, field.id)}
                style={{ display: "none" }}
              />
            </div>
          </div>
        );
      })}

      <div className="become-volunteer__btn-box" style={{ textAlign: "end" }}>
        <button
          type="submit"
          className="thm-btn become-volunteer__btn become-volunteer__submit mt-2"
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
      {/* <DeletePopUp open={open} setOpen={setOpen} onDelete={() => handleDelete(fieldName)} /> */}
      <QrPopup open={qrOpen} onClose={() => setQrOpen(false)} />
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={lightboxSlides}
        plugins={[Counter, Zoom, Thumbnails, Captions]}
      />
    </>
  );
};

export default Uploads;
